import {apiWithToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    postItemLog: (datas) => apiWithToken.put(API_URL.ADD_NOTE_ITEM.replace("{id}", datas.id) , {...datas}, {loading: false}),
};